import { resolveVerifyEmailLayout } from '~/utils/resolveVerifyEmailLayout'
import { holdsCustomerRole } from '~/utils/holdsCustomerRole'
import { resolveRoleNames } from '~/utils/resolveRoleNames'
import { useIdentity } from '~/composables/useIdentity'
import { findLifecycleOccurredAt } from '~/utils/findLifecycleOccurredAt'

export default defineNuxtRouteMiddleware(() => {
  const { isAuthenticated, identity } = useIdentity()
  const userStore = useUserStore()
  // Prefer the Sanctum identity and fall back to the Pinia store when the
  // session is authenticated but the identity ref is still synchronizing.
  const resolvedUser = identity.value ?? userStore.user
  const isCustomerRole = holdsCustomerRole(resolveRoleNames(resolvedUser))

  // In middleware, Nuxt defers setPageLayout through router.beforeResolve.
  // Redirect first so the verify-email layout cannot leak onto the destination.
  if (findLifecycleOccurredAt(resolvedUser, 'email_verified') !== undefined) {
    return navigateTo('/dashboard', { replace: true })
  }

  setPageLayout(resolveVerifyEmailLayout(isAuthenticated.value, isCustomerRole))
})
